<template>
    <div id="app">
        <router-view></router-view>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        if (window.location.host.split('.')[0] === 'nl') {
            this.addUrlMetas('https://nl.clarinsbnl.com/');
        } else {
            this.addUrlMetas('https://benl.clarinsbnl.com/');
        }
        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });

    },
    methods: {
        addUrlMetas(url) {
            const firstMeta = document.createElement('meta');
            const secondMeta = document.createElement('meta');
            firstMeta.setAttribute('property', 'og:url');
            firstMeta.setAttribute('content', url);
            secondMeta.setAttribute('property', 'og:image');
            secondMeta.setAttribute('content', url + 'preview.png');
            document.head.appendChild(firstMeta);
            document.head.appendChild(secondMeta);
        },
    },
};
</script>
<style>

</style>
